<template>
    <div class="login wrapper bg-magenta-dark">
        <div class="main">
            <div class="no-box">
                <div class="no-box-container">
                    <b-notification 
                        v-if="bagoDomainError"
                        :closable="false"
                        class="has-background-pink py-3 px-4 is-size-7">
                        <strong>Error.</strong> Sólo podés acceder usando tu cuenta @bago.com.ar
                    </b-notification>

                    <img src="/images/cnv-bago.svg" width="150" heigth="135" alt="CNV Bagó 2023">
                    <div v-if="!OcultarLogin || showLogin">
                        <div class="my-5 py-3 text-balanced  has-text-centered is-size-5 is-size-6-mobile">Iniciá sesión con tu mail de Bagó para comenzar</div>

                        <b-button
                            type="is-primary"
                            outlined
                            expanded
                            @click="GoogleAuth()"
                            :loading="!$store.state.site_settingsLoaded">
                            Iniciar sesión
                        </b-button>
                    </div>
                    <div v-else>

                        <p class="is-uppercase is-size-6 mt-5 pt-3">Próximamente</p>

                    </div>
                </div>
            </div>
        </div>
        <footer class="is-size-7-mobile">
            <div>
                <img src="images/logo-bago.svg" alt="Laboratorios Bagó">
            </div>
            <div>© 2025 Bagó S.A. Todos los derechos reservados</div>
        </footer>
    </div>
</template>
  
<script>
import { supabase } from '@/supabase'

export default {
components: {},
props: {
    showLogin: {
      type: Boolean,
      default: false
    }
},
data() {
    return {
        bagoDomainError: false
    };
},
methods:{
    async GoogleAuth(){
        await supabase.auth.signInWithOAuth({
            provider: 'google',
        })
    },
    MailEstaPermitido(mail){
        if(this.mailsPermitidos.includes(mail)){ return true }
        const proveedorMail = mail.split("@")[1]
        if(this.casillasPermitidas.includes(proveedorMail) ){return true }
        return false
    }
},
computed:{
    settingsLoaded(){
        return this.$store.state.site_settingsLoaded
    },
    mailsPermitidos(){
        return this.$store.state.site_settings.mailsPermitidos || []
    },
    casillasPermitidas(){
        return this.$store.state.site_settings.casillasPermitidas || []
    },
    OcultarLogin(){
        if(this.$store.state.site_settings.ocultar_login == undefined) return true
        return this.$store.state.site_settings.ocultar_login
    }
},
watch:{
},
async mounted() {
    this.$nextTick(async() => {
        const { data } = await supabase.auth.getSession()
        // console.log("******** GET SESSION")
        // console.log("User session", data, error)
        if(!data.session?.user){ return }
        const user = data.session.user.user_metadata
        const token = data.session.access_token
        
        if( this.MailEstaPermitido(user.email)){
            this.$store.commit("UserLoggedIn", {user, token})
            this.$router.push("evento")
        }else{

            this.bagoDomainError = true
            const { error } = await supabase.auth.signOut()
            if(error){
                console.log("error on user sign out", error)
            }else{
                console.log("user logged out")
                this.$store.commit("UserLoggedOut")
            }
        }
    })
}
}
</script>
<style lang="css" scoped>

.wrapper {
    display: flex;
    flex-direction: column;
    height: 100vh;
}
.main {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-grow: 1;
    overflow-x: hidden;
    overflow-y: auto;
}

.no-box {
    width: 100%;
    max-width: 400px;
    margin: 1em;
    padding: 2em;
    display: flex;
    justify-content: center;
    border-top: dashed 1px rgba(255,255,255,0.3);
    border-bottom: dashed 1px rgba(255,255,255,0.3);

}

.no-box-container {
    max-width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
}
.no-box-container .img {
    width: 150px;
}

.button:before {
    content: '';
    display: block;
    background-image: url("data:image/svg+xml,%3Csvg style='color: rgb(221, 58, 165);' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='none'%3E%3C/rect%3E%3Cpath d='M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,184A80,80,0,1,1,184.6,71.4a8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A64.1,64.1,0,1,0,191.5,136H128a8,8,0,0,1,0-16h72a8,8,0,0,1,8,8A80.1,80.1,0,0,1,128,208Z' fill='%23dd3aa5'%3E%3C/path%3E%3C/svg%3E");
    width: 1.1em;
    height: 1.1em;
    background-size: cover;
    margin-right: 0.3em;
}

.button:focus:before,
.button.is-focused:before,
.button:hover:before,
.button.is-hovered:before{
    background-image: url("data:image/svg+xml,%3Csvg style='color: white' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='none'%3E%3C/rect%3E%3Cpath d='M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,184A80,80,0,1,1,184.6,71.4a8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A64.1,64.1,0,1,0,191.5,136H128a8,8,0,0,1,0-16h72a8,8,0,0,1,8,8A80.1,80.1,0,0,1,128,208Z' fill='white'%3E%3C/path%3E%3C/svg%3E");
}

footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    padding: 1em 2em;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.05);
}

footer img {
    width: 80px;
}

@media screen and (max-width: 768px){
    footer {
        flex-direction: column;
        text-align: center;
    }

    footer img {
    width: 60px;
    }
}

:deep(button.is-primary:hover) {
    &:hover {
        background-color: #dd3aa5;
    }
}
</style>
